import { render, staticRenderFns } from "./GeneralEffectModal.vue?vue&type=template&id=4454bb56&"
import script from "./GeneralEffectModal.vue?vue&type=script&lang=js&"
export * from "./GeneralEffectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports